//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import TaxDocumentsList from '@/views/Sale/SlTaxDocument/SlTaxDocumentList'

//
export default {
  path: 'cont_sale_documents',
  component: ModuleLayout,
  children: [
    {
      path: '',
      name: 'sl-tax-document-list',
      component: TaxDocumentsList,
    },
  ],
  meta: {
    title: 'Documentos de venta',
  },
}
